import { Logout, Login } from '@mui/icons-material';
import { format } from 'date-fns';
import React from 'react';
import { FaUserAlt } from 'react-icons/fa';
import ReactModal from 'react-modal';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../auth/UseUser';

function ProfilModal({ modalIsOpen, closeModal }: any) {
    const {
        isSignedIn,
        user,
        setUser,
        setIsAdminApp,
        setTipEtiteta,
        setShowSelectedPuskica,
        setSelectedPuskica,
        setSelectedPitanja,
        setNavLista,
        setReturnedList,
    } = useUser();
    const navigate = useNavigate();

    const logout = () => {
        if (window.confirm('Da li ste sigurni da želite da se odjavite?')) {
            localStorage.clear();
            setUser({});
        }
    };

    const handleLoginButton = () => {
        navigate('/login');
        setShowSelectedPuskica(false);
        setSelectedPuskica(null);
        setSelectedPitanja([]);
        setIsAdminApp(false);
    };
    return (
        <ReactModal
            ariaHideApp={false}
            isOpen={modalIsOpen}
            closeTimeoutMS={300}
            onRequestClose={closeModal}
            className="no-scroll"
            style={{
                overlay: {
                    zIndex: 5,
                    backgroundColor: '#00000090',
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'flex-end', // Postavlja modal pri dnu
                    justifyContent: 'center',
                    outline: 'none',
                },
                content: {
                    padding: 0,
                    paddingRight: 10,
                    paddingLeft: 10,
                    opacity: 1,
                    maxWidth: 600,
                    width: '100%',
                    backgroundColor: 'transparent',
                    maxHeight: 'fit-content',
                    position: 'relative',
                    transform: modalIsOpen ? 'translateY(0)' : 'translateY(100%)',
                    transition: 'transform 0.3s ease-in-out', // Animacija otvaranja
                    outline: 'none',
                },
            }}
        >
            <div className=" w-full bg-white text-black rounded-t-[10px] shadow-lg pb-5 z-[11]">
                <div className=" flex flex-col items-center justify-center gap-1  bg-blueSuperLight h-20 rounded-t-[10px]">
                    <p className="mt-[55px] text-grey-800 font-semibold text-[14px] leading-5">{user?.username ?? 'Neprijavljen korisnik'}</p>
                    <div className="min-w-16 max-w-16 min-h-16 rounded-full bg-[#aaaaaa] flex items-center justify-center border border-white">
                        {!!user?.username ? (
                            <p className="text-[20px] leading-[24px] font-medium text-[#000000] ">{user?.username[0]}</p>
                        ) : (
                            <FaUserAlt size={30} color="#424242" />
                        )}
                    </div>
                </div>
                <p className="mt-8 text-[14px] leading-[20px] font-medium text-grey-800 text-center">{user?.email}</p>
                <div className="flex flex-col px-3">
                    {isSignedIn && (
                        <div className="flex flex-row justify-between mt-5">
                            <p className="text-grey-800 font-semibold text-[14px] leading-5">Vazenje pretplate</p>
                            <p className="text-grey-800 font-medium text-[14px] leading-5">{format(user?.endDate ?? null, 'dd.MMM.yyyy HH:mm')}</p>
                        </div>
                    )}
                    <div className="border-b border-b-grey-A700 mt-5"></div>
                    {isSignedIn ? (
                        <button className="flex flex-row mt-5 items-center gap-2 " onClick={() => logout()}>
                            <Logout />
                            <p className="text-grey-800 font-semibold text-[14px] leading-5 hover:text-grey-900">Odjavite se</p>
                        </button>
                    ) : (
                        <button className="flex flex-row mt-5 items-center gap-2 " onClick={() => handleLoginButton()}>
                            <Login />
                            <p className="text-grey-800 font-semibold text-[14px] leading-5 hover:text-grey-900">Prijavite se</p>
                        </button>
                    )}
                </div>
            </div>
        </ReactModal>
    );
}

export default ProfilModal;
